import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/img/logo.png';
import { FieldGroup, FormBuilder, Validators, FieldControl } from 'react-reactive-form';
import { forgotPassword } from '../services/commonServices';
import { useSnackbar } from 'notistack'

function ForgotPassword() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar()
    const loginForm = FormBuilder.group({
        email: ["", [Validators.required, Validators.email]]
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loginForm.valid) {
            let data = await forgotPassword({ ...loginForm.value });
            if (data.status === 200) {
                enqueueSnackbar(data.data.message,
                    { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                navigate('/otp-validation');
            }
            else {
                enqueueSnackbar(data.response.data.message,
                    { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } }
                )
            }

        } else {
            loginForm.markAsTouched();
            enqueueSnackbar("Please fill the valid email",
                { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } }
            )
        }
    }

    return (
        <div >
            <div className="row gx-0">
                <div className="col-md-6 d-flex align-items-center justify-content-center">
                    <div className="logo text-center" style={{ backgroundColor: "#1F6566", height: "100%", width: "100%" }}>
                        <img style={{ height: "75%", width: "75%", marginTop: "10%" }} src={Logo} alt="Logo" />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="login_right_side">
                        <div className="change_password" style={{ marginTop: "15%" }}>
                            <h2 className="text-center pb-2">Forgot password?</h2>
                            <p className=" text-center mb-5">
                                Don't worry. Resetting your password is easy. Just tell
                                us <br></br> the email address that was used to create this account.
                            </p>
                            <FieldGroup
                                control={loginForm}
                                render={({ pristine, invalid, pending, value }) => (
                                    <form onSubmit={handleSubmit}>
                                        <FieldControl
                                            name='email'
                                            render={({ handler, touched, hasError }) => (
                                                <div className="form-group">
                                                    <label htmlFor="email">Email Address</label>
                                                    <input type="email" className="form-control form-control1 mb-0" {...handler()} id="email" />
                                                    <div className='invalid-feedback d-block errorText mb-2'>
                                                        <span className='errorText'>
                                                            {(touched &&
                                                                ((hasError("required") && "Email is required") ||
                                                                    (hasError("email") &&
                                                                        "Please enter a valid email")))}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                        <div className="form-group custom-input">
                                            <button type="submit" className="btn text-center">
                                                RESET PASSWORD
                                                {/* <ng-container *ngIf="!loading">RESET PASSWORD</ng-container> */}
                                            </button>
                                        </div>
                                        <div className="text-center mt-4 textHover">
                                            <Link to='/login' className="secondry-color">Back to Login</Link>
                                        </div>
                                    </form>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword;